import { ChangeEvent, useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonInput from "../../../components/common/form/input/CommonInput";
import { signin } from "../../../apis/authApi";
import useUiuxStore from "../../../store/useUiuxStore";
import { FindAccountModal } from "../../../components/auth/FindAccountModal";
import useUserStore from "../../../store/useUserStore";
import { PrinterSettingModal } from "src/components/common/modal/printerSettingModal/PrinterSettingModal";
import { markAuthSession, markLoginRecorded } from "src/utils/auth/authConfig";

const SigninContainer = () => {

	const navigate = useNavigate();

	const { findAccountModalVisible, setFindAccountModalVisible, isPrinterSettingModalOpen, setIsPrinterSettingModalOpen } = useUiuxStore();

	const [inputData, setInputData] = useState({
		id: '',
		pw: '',
	});

	const idRef = useRef<HTMLInputElement>(null);
	const pwRef = useRef<HTMLInputElement>(null);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setInputData(prev => ({ ...prev, [name]: value }));
	};

	const handleSigninClick = useCallback(async () => {
		const { id, pw } = inputData;

		const response = await signin(id, pw);
		console.log(response);
		if (response?.data?.successFlag) {
			markAuthSession();
			markLoginRecorded();
			navigate('/');
		}

	}, [inputData])

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter' && e.currentTarget.name === 'id')			pwRef.current?.focus();
		else if (e.key === 'Enter' && e.currentTarget.name === 'pw')	handleSigninClick();
	}

	return (
		<div
			className="w-full h-full flex flex-col justify-center items-center"
			style={{
				backgroundImage: 'url(/images/background/backGroundImage.jpg)',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat'
			}}
		>
			<div className="w-[400px] min-h-[600px] flex flex-col bg-blue-darkest items-center border-x-[10px] border-y-[10px] border-blue-darkest px-[16px] rounded-[18px]">
				<div className="w-[380px] min-h-[600px] flex flex-col gap-[10px] bg-white rounded-[18px] py-[20px] px-[10px]">

					{/* 로고영역 */}
					<div className="flex flex-row items-center gap-[15px] mt-[15px] "  >
						<img src="/images/logo/IMAGE.jpg" className="h-[60px] object-contain" alt="로고" />
						<p className=" text-blue-800 text-[30px] font-bold">
							{process.env.REACT_APP_DEFAULT_COMPANY_NAME || "라온정보랩스"}
						</p>
					</div>
					<div className="flex justify-end mt-[5px]">
						<p className="text-[18px] text-black-800 font-bold">
							{process.env.REACT_APP_POSTGRES_JP || " "}
						</p>
					</div>

					{/* 타이틀영역 */}
					<div className="w-full flex flex-col gap-[1px] mt-[10px]">
						<p className="text-left text-[18px] text-gray-700 font-bold">
							Welcome To
						</p>
						<p className="text-center text-[30px] text-blue-800 font-bold">
							Raonzena MES Ver 1.0
						</p>
					</div>

					{/* id,pw 영역 */}
					<div className="w-full flex flex-col justify-center items-start gap-[2px] mt-[30px]">
						<p className="text-[15px] text-gray-700 font-semibold text-left">
							아이디
						</p>
						<CommonInput className="w-full mb-8"
							value={inputData.id} name="id" ref={idRef}
							onChange={handleChange}
							onKeyDown={handleKeyDown}
							placeholder={"아이디"}
						/>
						<p className="text-[15px] text-gray-700 font-semibold text-left">
							비밀번호
						</p>
						<CommonInput className="w-full"
							value={inputData.pw} name="pw" type="password" ref={pwRef}
							onChange={handleChange}
							onKeyDown={handleKeyDown}
							placeholder={"비밀번호"}
						/>
					</div>
					{/* 로그인, 회원가입 영역*/}
					<div className="w-full flex flex-col justify-start items-center gap-[8px] mt-[20px]">
						<button className={`text-white w-full rounded-[10px] bg-blue-darkest text-[18px] leading-[18px] font-semibold py-[18px]`}
							onClick={handleSigninClick}>
							로그인
						</button>
						<button
							className={`text-blue hover:text-blue-dark focus:outline-none`}
							style={{
								background: 'none',
								border: 'none',
								padding: '0',
								cursor: 'pointer',
							}}
							onClick={() => setFindAccountModalVisible(true)}
						>
							아이디, 비밀번호 찾기
						</button>
						<button
							type="button"
							className="flex items-center justify-center  cursor-pointer hover:opacity-80 transition-opacity"
							onClick={() => setIsPrinterSettingModalOpen(true)}
							title="프린터 설정"
						>
							<img
								src={`${process.env.PUBLIC_URL || ''}/print/Scan.png`}
								alt="프린터 설정"
								className="h-8 w-auto object-contain"
							/>
						</button>

					</div>
				</div>
			</div>
			<PrinterSettingModal
				isOpen={isPrinterSettingModalOpen}
				onClose={() => setIsPrinterSettingModalOpen(false)}
			/>
			{findAccountModalVisible && <FindAccountModal />}
		</div>
	)
}

export default SigninContainer;